import { MutableRefObject } from 'react'
import { GridColDef } from '@microservices/wiskey-react-table-component'
import { GridApiPro } from '@microservices/wiskey-react-table-component/dist/DataGrid/DataGridV7/models/gridApiPro'

import { useHandlers, useInputs } from '@pages/TimeLineCreateOrEdit'

import { VariableValue } from '@components/Variables/types'

import { EmbeddedObject } from '@gantt/components/GanttCreateOrEdit'

import { ActionRow } from './action'
import { ObjectDataRecord } from './api'
import { FormCommand } from './command'
import { AutocompleteOption } from './common'
import { ConfiguredColumn } from './views'

export type ObjectY = {
  // Код объекта
  objectCode?: string
  // Название объекта
  objectTitle?: string
  // Данные по объекту
  object?: AutocompleteOption
  // Параметры команды для загрузки данных по объекту
  getDataCommand: FormCommand
  // Ключевое поле объекта Y, по которому будет соединяться объект X
  keyField: AutocompleteOption | null
  // Предварительная фильтрация объекта Y
  preFilter?: string | null
  // Колонки для отображения
  columns: ConfiguredColumn[]
  // Действия
  actions: ActionRow[]
  entityId?: number
}

export type ObjectX = {
  // Код объекта
  objectCode?: string
  // Название объекта
  objectTitle?: string
  // Данные по объекту
  object?: AutocompleteOption
  // Параметры команды для загрузки данных по объекту
  getDataCommand: FormCommand
  // Поле из модели объекта, обозначающее начало интервала
  startDateField: AutocompleteOption | null
  // Поле из модели объекта, обозначающее конец интервала
  endDateField: AutocompleteOption | null
  // Конфигурация ссылки на ObjectY
  linkToObjectY: {
    keyField: string | null
    pathArray: EmbeddedObject[]
  }
  // Конфигурация ячейки
  cell: TimeLineGridXCell
  // Колонки для отображения после основных колонок объекта X
  columns: ConfiguredColumn[]
  // Действия
  actions: ActionRow[]
  totalsRows: TotalRow[]
  entityId?: number
}

export const enum GroupTitleType {
  JS = 'JS',
  JSX = 'JSX',
  FIELD = 'FIELD',
}

export const enum MainObjectTypeEnum {
  Y = 'Y',
  X = 'X',
}

export type MainObjectType = {
  objectType: MainObjectTypeEnum
  groupTitleType?: AutocompleteOption<GroupTitleType> | null
  groupTitleScript?: string
  groupTitleDisplayField?: EmbeddedObject[] | null
  groupTitleDisplayFieldKey?: string
  groupField?: EmbeddedObject[] | null
  groupFieldKey?: string
}

export const enum INCREMENT_TYPE {
  MINUTE = 'MINUTE',
  HOUR = 'HOUR',
  DAY = 'DAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
  YEAR = 'YEAR',
}

export type TimeLineGridInterval = {
  increment: INCREMENT_TYPE
  dateRange?: [string, string]
  showFilter: boolean
}

export type TimeLineGridConfig = {
  id?: number
  title: string
  code: string
  jsonConfig?: string
  timeInterval: TimeLineGridInterval
  objectY: ObjectY
  objectX: ObjectX
  mainObject: MainObjectType
  showUpdateTimeLineDataButton: boolean
  actions: ActionRow[]
  variables: VariableValue[]
  showDayOfWeek: boolean
}

export type TimeLineGroupedData = {
  yElement: ObjectDataRecord
  xArray: ObjectDataRecord[]
}

export type DateIntervalKey = {
  // Здесь будут лежать ключи, сформированные на основе интервала дат в виде [start;end]
  [key in `[${string};${string}]`]?: ObjectDataRecord[]
}

export type TimeLineGridDataRecord = {
  id: string
  yElement: ObjectDataRecord
  value?: unknown
  groupId?: string
  title?: string
} & DateIntervalKey

export type TimeLineGridXCell = {
  bindType: AutocompleteOption | null
  value: string
  entity?: AutocompleteOption | null
}

export type TimeLineGridColumn = {
  columnType?: COLUMN_TYPE
} & GridColDef

export type TimeLineCreateOrEditPageContextType = {
  inputs: ReturnType<typeof useInputs>
} & ReturnType<typeof useHandlers>

export type DataGridRefType = MutableRefObject<GridApiPro>

export type TotalRow = {
  commands: FormCommand[]
  bindType: AutocompleteOption | null
  script: string
  title: string
  id?: string
}

export const enum COLUMN_TYPE {
  OBJECT_Y = 'objectY',
  OBJECT_X = 'objectX',
  DATE_INTERVAL = 'dateInterval',
}
